import React from 'react'
import Provider from '@@/core/plugin-model/Provider';
import { ModelsProvider } from './model';

export function dataflowProvider(element, args = {}){
    return <ModelsProvider {...args} >
                <Provider {...args}>{element}</Provider>
           </ModelsProvider>
}
// generated at 2026/7/8 18:49:32 by sui v3.1.128